var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_243_3316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0942 8.89669C10.0942 11.5794 7.93814 13.7541 5.27863 13.7541C2.61913 13.7541 0.462891 11.5789 0.462891 8.89669C0.462891 6.21447 2.61896 4.03906 5.27863 4.03906C7.9383 4.03906 10.0942 6.21398 10.0942 8.89669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3763 8.8973C15.3763 11.4225 14.2983 13.4704 12.9684 13.4704C11.6386 13.4704 10.5605 11.4225 10.5605 8.8973C10.5605 6.3721 11.6384 4.32422 12.9683 4.32422C14.2981 4.32422 15.3761 6.37145 15.3761 8.8973",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5373 8.89754C17.5373 11.1595 17.1582 12.9943 16.6904 12.9943C16.2227 12.9943 15.8438 11.16 15.8438 8.89754C15.8438 6.63509 16.2228 4.80078 16.6904 4.80078C17.158 4.80078 17.5373 6.63493 17.5373 8.89754Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_243_3316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.075,
    height: 17.075,
    fill: "white",
    transform: "translate(0.462891 0.197266)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.015d5269728046fe6af2d18b6204b4ba.svg";
export { ForwardRef as ReactComponent };